(() => {
  angular.module('app').controller('clinic.views.hospital.requestIgl.page', RequestIglController);

  RequestIglController.$inject = [
    '$scope',
    '$stateParams',
    '$state',
    '$uibModal',
    'abp.services.app.hospitalPanelServiceRequest',
    'abp.services.app.commonLookup',
    'moment',
    'appConstants'
  ];

  function RequestIglController(
    $scope,
    $stateParams,
    $state,
    $uibModal,
    hospitalPanelServiceRequestSvc,
    commonLookupSvc,
    moment,
    appConstants
  ) {
    const vm = this;

    vm.createDoctor = createDoctor;
    vm.refreshDoctors = refreshDoctors;
    vm.updateDoctor = updateDoctor;
    vm.prevTab = prevTab;
    vm.nextTab = nextTab;
    vm.setActiveTab = setActiveTab;
    vm.save = save;
    vm.saveDraft = saveDraft;
    vm.downloadPatientConsentForm = downloadPatientConsentForm;
    vm.downloadDoctorAdmissionForm = downloadDoctorAdmissionForm;
    vm.dateValidation = dateValidation;
    vm.admissionDateValidation = admissionDateValidation;

    vm.loading = 0;
    vm.letter = null;
    vm.employeeId = $stateParams.employeeId;
    vm.panelLocationId = $stateParams.panelLocationId;
    vm.requestId = $stateParams.requestId;
    vm.sourceLetterNumber = $stateParams.sourceLetterNumber;
    vm.caseId = $stateParams.caseId;
    vm.hubPatientId = $stateParams.hubPatientId
      ? decodeURIComponent($stateParams.hubPatientId)
      : null;
    vm.hubPolicyId = $stateParams.hubPolicyId
      ? decodeURIComponent($stateParams.hubPolicyId)
      : null;
    vm.activeTab = 0;
    vm.doctors = [];
    vm.patient = {};
    vm.newAttachments = [];
    vm.attachments = [];
    const fileExtensions =
      `|${ 
      appConstants.fileUpload.imageExtensions.concat(appConstants.fileUpload.pdfExtensions).join('|') 
      }|`;
    vm.uploadConfig = {
      objectType: 'InpatientIglRequestAttachment',
      itemsLimit: 3,
      accept: 'image/*,application/pdf',
      filters: [
        {
          name: 'fileFilter',
          fn(n) {
            const t = `|${  n.type.slice(n.type.lastIndexOf('/') + 1)  }|`;
            if (fileExtensions.indexOf(t) === -1) {
              abp.message.warn(App.localize('File_Warn_FileType'));
              return false;
            }
            return true;
          },
        },
        {
          name: 'sizeFilter',
          fn(n) {
            const sizeLimit = 52428800;
            if (n.size > sizeLimit) {
              abp.message.warn(App.localize('File_Warn_XSizeLimit', sizeLimit / 1024 / 1024));
              return false;
            }
            return true;
          },
        },
      ],
    };

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.permissions = {
      createDoctor: abp.auth.isGranted('Clinic.Doctors.Create'),
    };
    vm.hasInpatientRegionalExpansion = abp.setting.getBoolean(
      'Hms.Feature.RegionalExpansionForInpatient'
    );

    init();

    function init() {
      if (vm.hasInpatientRegionalExpansion) {
        getLanguage();
        getCurrency();
      }
      getRequestInitialGuaranteeLetter();
    }

    function getLanguage() {
      vm.loading += 1;
      commonLookupSvc
        .getDefaultLanguageByCountryCode()
        .success((data) => {
          vm.language = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getCurrency() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCurrencyCode()
        .success((data) => {
          if (data) vm.currencyCode = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getRequestInitialGuaranteeLetter() {
      vm.loading += 1;
      hospitalPanelServiceRequestSvc
        .getRequestGuaranteeLetter({
          employeeId: vm.employeeId,
          panelLocationId: vm.panelLocationId,
          requestId: vm.requestId,
          sourceLetterNumber: vm.sourceLetterNumber,
        })
        .success((data) => {
          vm.letter = data.letter;
          vm.patient = data.patient;
          vm.panel = data.panel;
          vm.doctors = data.doctors;
          vm.admissionTypes = data.availableAdmissionTypes;
          vm.attachments = vm.letter.attachments;
          vm.newAttachments = [];

          _.each(vm.letter.documentChecklistItems, (item) => {
            item.required = item.isMandatory;
            item.isChecked = item.isSelected;
          });
          updateDoctor();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function prevTab() {
      setActiveTab(vm.activeTab - 1);
    }

    function nextTab() {
      if (vm.activeTab === 2) {
        return;
      } if (vm.activeTab === 0 && !App.isFormValid($scope.forms.admissionDetails)) {
        return;
      } if (vm.activeTab === 1) {
        vm.invalidAttachment = vm.newAttachments.length < 1 && vm.attachments.length < 1;
        vm.invalidChecklist =
          !App.isFormValid($scope.forms.uploadDocuments) &&
          _.some(vm.letter.documentChecklistItems, (d) => d.required && !d.isChecked);

        if (vm.invalidAttachment || vm.invalidChecklist) {
          return;
        }
      }

      setActiveTab(vm.activeTab + 1);
    }

    function setActiveTab(tab) {
      if (tab < 0 || tab > 3) return; // Prevent tab out of range.

      vm.activeTab = tab;
    }

    function updateDoctor() {
      vm.admittingDoctor = vm.doctors.find((d) => d.id === vm.letter.doctorId);
    }

    function save() {
      if (vm.saving) return;

      const checklistItems = [];
      _.each(vm.letter.documentChecklistItems, (item) => {
        checklistItems.push({
          text: item.text,
          isSelected: item.isChecked,
          isMandatory: item.required,
        });
      });

      const attachments = [];
      _.each(vm.attachments, (attachment) => {
        if (!attachment.isDelete) attachments.push(attachment.id);
      });

      const input = $.extend(vm.letter, {
        serviceRequestId: vm.requestId,
        employeeId: vm.patient.id,
        panelLocationId: vm.panel.id,
        documentChecklistItems: checklistItems,
        attachments,
        newAttachments: vm.newAttachments,
        caseId: vm.caseId,
        hubPatientId: vm.hubPatientId,
        hubPolicyId: vm.hubPolicyId
      });

      vm.saving = true;
      hospitalPanelServiceRequestSvc
        .requestInitialGuaranteeLetter(input)
        .success(() => {
          abp.notify.info(App.localize('SuccessfullySubmitted'));
          $state.go('clinic.inpatientDashboard');
        })
        .finally(() => {
          vm.saving = false;
        });
    }

    function saveDraft() {
      if (vm.saving) return;

      const checklistItems = [];
      _.each(vm.letter.documentChecklistItems, (item) => {
        checklistItems.push({
          text: item.text,
          isSelected: item.isChecked,
          isMandatory: item.required,
        });
      });

      const attachments = [];
      _.each(vm.attachments, (attachment) => {
        if (!attachment.isDelete) attachments.push(attachment.id);
      });

      const input = $.extend(vm.letter, {
        serviceRequestId: vm.requestId,
        employeeId: vm.patient.id,
        panelLocationId: vm.panel.id,
        documentChecklistItems: checklistItems,
        attachments,
        newAttachments: vm.newAttachments,
        caseId: vm.caseId,
        hubPatientId: vm.hubPatientId,
        hubPolicyId: vm.hubPolicyId
      });

      vm.saving = true;
      hospitalPanelServiceRequestSvc
        .requestDraftGuaranteeLetter(input)
        .success((requestId) => {
          vm.requestId = requestId;
          abp.notify.info(App.localize('SuccessfullySaved'));
        })
        .finally(() => {
          vm.saving = false;
          $state.reload({ requestId: vm.requestId });
        });
    }

    function downloadPatientConsentForm(language) {
      const option = {
        employeeId: vm.employeeId,
        panelLocationId: vm.panelLocationId,
        languageCode: language,
      };
      window.open(App.formatUrl('Print/PatientConsent?', option));
    }

    function downloadDoctorAdmissionForm(language) {
      const option = {
        employeeId: vm.employeeId,
        panelLocationId: vm.panelLocationId,
        languageCode: language,
      };
      window.open(App.formatUrl('Print/AttendingPhysicianStatement?', option));
    }

    function createDoctor() {
      $uibModal
        .open({
          templateUrl: require('../../doctors/createOrEditModal.html'),
          controller: 'clinic.views.doctors.createOrEditModal as vm',
          backdrop: 'static',
          resolve: {
            doctorId: null,
            clinicLocationId: vm.panelLocationId,
          },
        })
        .result.then((result) => {
          vm.refreshDoctors(result.doctorId);
        });
    }

    function refreshDoctors(doctorId) {
      hospitalPanelServiceRequestSvc
        .getPanelLocationDoctors({
          id: vm.panelLocationId,
        })
        .success((data) => {
          vm.doctors = data.items;
        })
        .finally(() => {
          if (!vm.doctors.length) {
            vm.createDoctor();
          }
          vm.letter.doctorId = parseInt(doctorId, 10);
          updateDoctor();
        });
    }

    function dateValidation(value, otherDate) {
      return moment(value).diff(moment(otherDate), 'days') > -1;
    }

    function admissionDateValidation(value) {
      // For admission type of accident only.
      const check = moment(value).diff(moment(Date.now()), 'days') < 0;
      return check;
    }
  }
})();
